import { WebSocketReceiveWithSigningUserId } from './web-socket-receive-with-signing-user-id';

export class WebSocketReceiveReloadVariantBadge extends WebSocketReceiveWithSigningUserId {
  override payload: {
    CompanyId: string;
    FileName: string;
    Id: string;
    SigningUserId: string;
  };
}
